module.exports = __webpack_public_path__ + "static/img/pass_logo.2d0f5380.png";